import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export interface TenantSummary {
  id: string;
  slug: string;
  name: string;
  lifecycle_state: "prospect" | "trial" | "active" | "delinquent" | "suspended" | "churned" | "archived";
  created_at: string;
}

export function useTenants() {
  const [tenants, setTenants] = useState<TenantSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      const { data, error: err } = await supabase
        .from("tenants")
        .select("id, slug, name, lifecycle_state, created_at")
        .order("created_at", { ascending: false });
      if (cancelled) return;
      if (err) {
        setError(err.message);
      } else {
        setTenants((data ?? []) as TenantSummary[]);
      }
      setLoading(false);
    }
    load();
    return () => { cancelled = true; };
  }, []);

  return { tenants, loading, error };
}
